import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string[] | null;

const slice = createSlice({
  name: '$excludedChoiceSets',
  initialState,
  reducers: {
    setExcludedChoiceSets(state, action: PayloadAction<string[] | null>) {
      return action.payload;
    },
  },
});

export const { setExcludedChoiceSets } = slice.actions;
export default slice.reducer;
